import React, { FC } from 'react';
import './style.scss';
import Icon from '../icon';
import { iconSize } from '../../../constants/icon.constants';
import useHeroBanner from '../../../hooks/useHeroBanner';
import NavigationBarItem from './navItemList';
import RoutableNotEditableLink from '../routableNotEditableLink';
import { TNavigationBarListPops } from './types/navigationBar.types';
import { withTranslation, WithTranslation } from 'react-i18next';
import { googleNavClickEvent } from '../../../utils/analytics';
import { breadcrumb } from '../../../constants/analytics.constants';

const NavigationBarList: FC<WithTranslation & TNavigationBarListPops> = (props) => {
  const { breadcrumbItems, backButtonUrl, backButtonLabel, textColor, t = () => '' } = props;

  const isHeroBannerPresent = useHeroBanner();
  
  return (
    <>
     <nav className={isHeroBannerPresent ? 'nav-bar nav-bar__hero-banner nav-bar__with-alert' : 'nav-bar nav-bar__no-hero-banner'}>
        <div className="nav-bar__wrapper">
          <ul className="nav-bar__breadcrumb">
            {breadcrumbItems.map((item, i, self) => (
              <NavigationBarItem
                item={item}
                isLast={i === self.length - 1}
                key={`navigation-bar-item-${i}`}
                extraClassName={`nav-bar__item-text--${textColor}`}
              />
            ))}
          </ul>
          {!!backButtonUrl && (
            <RoutableNotEditableLink
              href={backButtonUrl}
              className={`nav-bar__back-button nav-bar__back-button-text--${textColor}`}
              onClick={() => {
                googleNavClickEvent(breadcrumb, backButtonUrl ?? '', backButtonLabel || (t('cnhi-backButton') as string));
              }}
            >
              <Icon iconName="arrow-simple-left" size={iconSize.mbl} extraClassName="nav-bar__back-icon" />
              <span>{backButtonLabel?.trim() || t('cnhi-backButton')}</span>
            </RoutableNotEditableLink>
          )}
        </div>
      </nav>
    </>
  );
};

export default withTranslation()(NavigationBarList);
